export default __webpack_public_path__ + "static/media/ribbon.b857832c.png";